/* global SwaggerUIBundle, SwaggerUIStandalonePreset, axios */

const app = {
  el: '#app',
  data: {
    host: 'vue3-course-api.hexschool.io',
  },
  methods: {
    async getData() {
      try {
        const res = await axios.get('./data/swagger_output.json');

        res.data.host = app.data.host;
        this.swaggerFn(res.data);
        this.hideModels();
        this.createdDesc();
      } catch (e) { /* empty */ }
    },
    hideModels() {
      // eslint-disable-next-line no-undef
      const models = document.querySelector('html body div#app section.swagger-ui.swagger-container div.swagger-ui div div.wrapper section.block.col-12.block-desktop.col-12-desktop section.models.is-open');
      models.remove();
    },
    createdDesc() {
      // eslint-disable-next-line no-undef
      const md = document.querySelector('html body div#app section.swagger-ui.swagger-container div.swagger-ui div div.information-container.wrapper section.block.col-12 div div.info div.description div.markdown');
      md.innerHTML = `<p>
        打破影音課程售後不理，我們在線上等著你。<br/>
        注意事項：登入成功後請點「Authorize」輸入 Token。<br/><br/>
        
        範例程式碼：
        <pre>
          <code>
  const config = {
    headers: { Authorization: token },
  };
  axios
    .post('/V2/api/user/check', {}, config)
      .then((res) => {
        console.log(res.data);
      }).catch((error) => {
        console.log(error.response.data);
      })
          </code>
        </pre>
      </p>
      `;
    },
    swaggerFn(data) {
      // eslint-disable-next-line no-undef
      window.ui = SwaggerUIBundle({
        spec: data,
        dom_id: app.el,
        deepLinking: true,
        presets: [
          SwaggerUIBundle.presets.apis,
          SwaggerUIStandalonePreset,
        ],
        plugins: [
          SwaggerUIBundle.plugins.DownloadUrl,
        ],
        layout: 'StandaloneLayout',
      });
    },
  },
  created() {
    this.methods.getData();
  },
};

// eslint-disable-next-line no-undef
window.onload = () => {
  app.created();
};
